import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Partners from '../views/Partners.vue'
import Products from '../views/Products.vue'
import Woundcare from '../views/Woundcare.vue'
import Diagnostic from '../views/Diagnostic.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/partners',
    name: 'Partners',
    component: Partners,
  },
  {
    path: '/products',
    name: 'Products',
    component: Products
  },
  {
    path: '/products/wound-care',
    name: 'Woundcare',
    component: Woundcare
  },
  {
    path: '/products/diagnostic',
    name: 'Diagnostic',
    component: Diagnostic
  }
  
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
